// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","shareLink":"_2yH5Y","shareIcon":"_1qklg"};